import * as api from '../api';
import { formatNumber, recalculate, formatDate, getCdnImageUrl } from "../functions";
import { getCustomerGuid } from "../customer";
import { Modal } from "./modal";

if ($('body').hasClass('page-customer-section')) {
	$('.list-customer-section-header .list-customer-section-navigation').append(`<li><a href="/klient/#subscription"><strong>Předplatné</strong></a></li>`);
	var subscriptions = [];
	var tableRow = function (item, data) {
		var subId = data.id;
		return `<tr class="single-merchandise">
                                    <td class="single-merchandise-info row">
                                       <div class="single-merchandise-foto large-2 medium-3 small-0 columns left">
                                          <a href="${item.url}" title="${item.name}">
                                          <img src="${getCdnImageUrl(`/user/shop/related/${item.image}`)}">
                                          </a>
                                       </div>
                                       <div class="single-merchandise-text-info large-10 medium-9 small-12 columns">
                                          <span class="text-wrapper" data-testid="cartProductName">
                                             <a href="${item.url}" class="main-link">${item.name}</a>
                                          </span>
                                       </div>
                                       <div class="clear">&nbsp;</div>
                                    </td>
                                   
                                    <td class="tac">
                                         
                                          <div>
                                           ${(data.status !== 'CANCELLED') ? `<form action="" method="post">
                                             <fieldset>
                                                <div class="relative">
                                                <a href="#" class="add-pcs icon-arrow-up-before" title="Zvýšit množství" data-testid="increase">&nbsp;</a>
                                                <a href="#" class="remove-pcs icon-arrow-down-before" title="Snížit množství" data-testid="decrease">&nbsp;</a>
                                                <span class="show-tooltip add-pcs-tooltip js-add-pcs-tooltip" aria-hidden="true" role="tooltip" data-testid="tooltip"></span>
                                                <span class="show-tooltip remove-pcs-tooltip js-remove-pcs-tooltip" aria-hidden="true" role="tooltip" data-testid="tooltip"></span>
                                                <input type="hidden" name="itemId" value="${item.id}" />
                                                <input type="hidden" value="${subId}" name="id" />
                                                <input type="hidden" value="${item.code}" name="productCode" />
                                                <input type="number" name="amount" value="${item.quantity}" class="pcs" data-decimals="0" data-max="9999" data-min="1" step="any" min="1" max="9999" data-testid="cartAmount">
                                                </div>
                                             </fieldset>
                                          </form>` : item.quantity + " Ks" }
                                       </div>
                                    </td>
                                    <td class="tac">
                                          ${item.discount.toFixed(0)} %
                                    </td>
                                    <td class="tac mobile-hide" data-testid="cartItemPrice">
                                       ${formatNumber(item.priceWithDiscount)} Kč
                                    </td>
                                    <td class="tac">
                                       <strong class="nowrap" data-testid="cartPrice">${formatNumber(item.priceWithDiscount*item.quantity)} Kč/obj</strong>
                                    </td>
                                    
                                    <td class="tac my-subscription">
                                    ${(data.status !== 'CANCELLED') ? `<form action="#" class="sub-delete" method="post">
                                          <fieldset>
                                             <input type="submit" value="x" class=" small button" aria-label="Odstranit z košíku">
                                             <input type="hidden" value="${item.id}" class="item-id">
                                             <input type="hidden" value="${subId}" class="id">
                                          </fieldset>
                                       </form>` : ''}
</td>
                                    
                                 </tr>`
	}
	var childrenTable = function (data) {

		var table = [];
		data.children.forEach(function (child) {
			var items = [];
			child.items.forEach(function (item) {
				items.push(tableRow(item, data));
			})

			table.push(`<table class="child" style="${(data.status === 'CANCELLED') ? 'opacity: 0.5; margin-bottom: 10px' : 'margin-bottom: 10px'}">
                              <colgroup>
                                 <col style="width: 45%">
                                 <col class="mobile-hide" style="width: 9%">
                                 <col style="width: 7%">
                                 <col class="mobile-hide" style="width: 12%">
                                 <col style="width: 10%">
                                 <col style="width: 5%">
                                
                              </colgroup>
                              <thead>
                                 <tr>
                                    <th class="tal">
                                       ${child.childName} <span class="add-product-info"><span> Pro přidání nového dítěte do programu HomeBox je nutné nově přidat požadované zboží do HomeBox košíku. Poté zvolte jméno Vašeho nového dítěte a v možnostech zvolte již aktivovaný požadovaný program.</span></span>  (${data.period.text})
                                    </th>
                                    <th class="tac">
                                       Množství
                                    </th>
                                    
                                    <th class="tac mobile-hide">
                                       Sleva
                                    </th>
                                    <th class="tac mobile-hide">
                                       Cena za kus
                                    </th>
                                    <th class="tac">
                                       Součet
                                    </th>
                                    
                                    <th class="tac"></th>
                                   
                                 </tr>
                              </thead>
                              <tbody>
                                ${items.join('')}
                              </tbody>
                           </table>`)

		})

		return table.join('');
	}

	var renderTable = function (data) {
		var rows = '';

		data.forEach(function (row, i) {
			var children = [];
			row.children.forEach(function (child) {
				children.push(child.childName);
			})
			rows += ` <tr class="${!((i % 2) === 0) ? 'even' : ''} ${(row.status === 'CANCELLED' ? 'subscription-canceled' : (row.status === 'PAUSED' ? 'subscription-paused' : 'subscription-active'))}"  style="opacity: ${row.status === 'CANCELLED' ? '0.5' : '1'}">
                            <td class="order-code">
                                <a href="#subscription-${i}" title="Zobrazit detail objednávky">
                                    <strong>${row.code}</strong>
                                </a>
                            </td>
                            <td>
                               ${children.length === 0 ? 'Nemáte žádné dítě v předplatném' : children.join(', ')}
                            </td>
                                                            <td>
                                  ${row.dateNextDelivery}
                                </td>
                                                        <td>${row.period.text}</td>
                                                        <td>${formatNumber(row.totalPrice)} Kč</td>
                                                        <td class="subscription-state">${(row.status === 'CANCELLED' ? 'Zrušeno' : (row.status === 'PAUSED' ? 'Pozastaveno' : 'Aktivní'))}</td>
                                                            <td><a href="#subscription-${i}">Zobrazit</a></td>
                        </tr> `;
		})

		if(rows === '') {
			return `<p id="my-subscription-empty">Aktuálně nemáte aktivní žádné předplatné. Jak si založit předplatné naleznete <a href="/predplatne-homebox/">zde</a>.</p>`
		}

		var content = `<table class="table-header-highlight subscriptions-list table-customer-section table-column-12">
                <thead>
                    <tr>
                        <th>Kód</th>
                        <th>Děti v předplatném</th>
                        <th>Další objednávka dne</th>
                        <th>Perioda odesílání</th>
                        <th>Cena celkem včetně DPH</th>
                        <th>Stav</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                  ${rows}
					 </tbody>
            </table>`;

		content += '<h3 id="calendar-title">Přehled následujících odeslání</h3>';
		content += '<div id="calendar-next-sending">Načítám...</div>';

		return content;
	}
	var renderDetail = function(data) {

		if (data.length === 0) {
			return `<div class="my-subscription"><p>Nemáte ještě aktivní přeplatné.</p></div>`
		}

		var buttonSwitchStatus = `<a href="#" class="btn btn-pause-subscription btn-switch-pause" data-id="${data.id}">Pozastavit</a>`;

		if(data.status === 'PAUSED') {
			$('body').addClass('sub-paused');
			buttonSwitchStatus = `<a href="#" class="btn btn-pause-subscription btn-switch-unpause" data-id="${data.id}" style="background-color: #519d2b">Obnovit</a>`;
		} else {
			$('body').removeClass('sub-paused');
		}


		var dateTable = '';

		var children = [];
		data.children.forEach(function (child) {
			children.push(child.childName);
		})

		data.calendar.forEach(function (date, i) {
			/* <td style="display: none">${data.code}</td>
								<td style="display: none">${children.length === 0 ? 'Nemáte žádné dítě v předplatném' : children.join(', ')}</td>
								<td style="display: none">${data.period.text}</td>
								*/
			dateTable += `
							<tr>
								<th style="padding: 5px 0">${date.replaceDate ? `<del>${formatDate(date.regularDate)}</del>` : formatDate(date.regularDate)}</th>
								
								<td>${data.code}</td>
								<td>${children.join(', ')}</td>
								<td>${data.period.text}</td>
								
								<td>
									<input type="date" data-id="${date.id}" data-subId="${data.id}" value="${date.replaceDate}" class="change-date" min="${date.minDate}" max="${date.maxDate}" />
								</td>
							</tr>
							</tr>`;
		})

		var smartSubscription = '';
		if(data.status !== 'CANCELLED') {
			if(data.smartSubscription) {
				smartSubscription = `<p>Máte aktivní režim chytrého předplatného <a href="#" id="cancel_smart_sub" data-id="${data.id}">Zrušit chytré předplatné</a></p>`;
			} else {
				smartSubscription = `<p>Nemáte aktivní režim chytrého předplatného <a href="#" id="active_smart_sub" data-id="${data.id}">Aktivovat chytré předplatné</a></p>`;
			}

		}

		return `<div class="my-subscription">
			<div class="address">
				<div class="address-item">
					<h3>Fakturační údaje</h3>
					
					<p>
						<strong>${data.firstname} ${data.lastname}</strong><br /> 
						Email: ${data.email}<br />
						Telefon: ${data.phoneNumber}<br />
						${data.address.street} ${data.address.houseNumber} <br/>
						${data.address.zipCode} ${data.address.city}<br />
						${data.address.country}
					</p>
					</div>
					<div class="address-item">
					<h3>Doručovací údaje</h3>
					
					${data.shippingAddress ? `<p>
						<strong>${data.shippingAddress.fullName}</strong><br /> 
						${data.shippingAddress.street} ${data.shippingAddress.houseNumber} <br/>
						${data.shippingAddress.zipCode} ${data.shippingAddress.city}<br />
						${data.shippingAddress.country}
					</p>` : `<p>Totožná s fakturační</p>`}
					
					</div>
				</div>
				
				<div id="cart-wrapper">
					${(data.status !== 'CANCELLED') ? `<a href="#" class="btn add-products">Přidat produkty</a>` : ''}
					
					<p class="msg msg-info">Veškerá změna se projeví v nové objednávce předplatného HomeBox.</p>
					
					<div id="cart">
					${(data.status == 'PAUSED') ? `<p style="color: red;"><strong>Předplatné pozastaveno dne ${formatDate(data.statusChangeAt)}</strong></p>` : ''}
					${(data.status == 'CANCELLED') ? `<p style="color: red;"><strong>Předplatné zrušeno dne ${formatDate(data.statusChangeAt)}</strong></p>` : ''}

					${childrenTable(data)}
					</div>
				</div>
				
				<div class="sub-footer">
					<p>Cena celkem včetně DPH: <strong>${formatNumber(data.totalPrice)} Kč/obj</strong></p>
					${(data.status !== 'CANCELLED') ? buttonSwitchStatus : ''}
				</div>
				
			${data.status === 'ACTIVE' ? `
				<h2><span class="subscription-calendar-title">Přehled následujících odeslání tohoto předplatného</span></h2>
				<table style="margin-bottom: 30px" class="subscription-calendar child">
					<thead>
						<tr>
							<th>Datum</th>
							<th>Kód</th>
							<th>Děti v předplatném</th>
							<th>Perioda odesílání</th>
							<th>Posunout na</th>
						</tr>
					</thead>
					<tbody id="date-content">
						${dateTable}
					</tbody>
				</table>` : ''}
				
				
				${smartSubscription}
				
				${(data.status !== 'CANCELLED') ? `<p>Nepřejete si již odebírat produkty? <a href="#" id="cancel_sub" data-id="${data.id}">Zrušit předplatné</a></p>` : ''}
				
				${Modal(`<div id="sub-active-smart-modal">
	                <div class="sub-order-box">
	                    <button type="button" class="sub-exit">
	                        <img src="/user/documents/upload/subimg/cross.svg" />
	                    </button>
	                    <h3>Opravdu si přejete aktivovat chytré předplatné?</h3>
	                   
	                   
	                    <button type="button" id="active-smart-sub-yes">ANO</button>
	                    <button type="button" id="active-smart-sub-no" style="background-color: #fe0000">NE</button>
	              
	                </div>
	            </div>`, 'active-smart-sub')}
				
				${Modal(`<div id="sub-cancel-smart-modal">
	                <div class="sub-order-box">
	                    <button type="button" class="sub-exit">
	                        <img src="/user/documents/upload/subimg/cross.svg" />
	                    </button>
	                    <h3>Opravdu si přejete zrušit chytré předplatné?</h3>
	                   
	                   
	                    <button type="button" id="cancel-smart-sub-yes">ANO</button>
	                    <button type="button" id="cancel-smart-sub-no" style="background-color: #fe0000">NE</button>
	              
	                </div>
	            </div>`, 'cancel-smart-sub')}
				
				${Modal(`<div id="sub-cancel-modal">
	                <div class="sub-order-box">
	                    <button type="button" class="sub-exit">
	                        <img src="/user/documents/upload/subimg/cross.svg" />
	                    </button>
	                    <h3>Opravdu si přejete zrušit toto předplatné?</h3>
	                   
	                   
	                    <button type="button" id="cancel-sub-yes">ANO</button>
	                    <button type="button" id="cancel-sub-no" style="background-color: #fe0000">NE</button>
	              
	                </div>
	            </div>`, 'sub-cancel-modal')}
				
				${Modal(`<div id="sub-pause-modal">
	                <div class="sub-order-box">
	                    <button type="button" class="sub-exit">
	                        <img src="/user/documents/upload/subimg/cross.svg" />
	                    </button>
	                    <h3>Opravdu si přejete pozastavit předplatné?</h3>
	                   
	                   
	                    <button type="button" id="pause-sub-yes">ANO</button>
	                    <button type="button" id="pause-sub-no" style="background-color: #fe0000">NE</button>
	              
	                </div>
	            </div>`, 'sub-pause-modal')}
				
				${Modal(`<div id="sub-pause-modal">
	                <div class="sub-order-box">
	                    <button type="button" class="sub-exit">
	                        <img src="/user/documents/upload/subimg/cross.svg" />
	                    </button>
	                    <h3>Opravdu si přejete obnovit předplatné?</h3>
	                   
	                   
	                    <button type="button" id="unpause-sub-yes">ANO</button>
	                    <button type="button" id="unpause-sub-no" style="background-color: #fe0000">NE</button>
	              
	                </div>
	            </div>`, 'sub-unpause-modal')}
				
				${Modal(`<div id="sub-pause-modal">
	                <div class="sub-order-box">
	                    <button type="button" class="sub-exit">
	                        <img src="/user/documents/upload/subimg/cross.svg" />
	                    </button>
	                    <h3>Přidání nového produktu</h3>
	                   
	                     <p>
	                     Jak přidat produkt do předplatného HomeBox<br />
	                        <ol>
	                        <li>Vyberte si v katalogu produkt a zvolte množství</li>
	                        <li>Klikněte na přidat do předplatného</li>
	                        <li>Vyberte vaše dítě</li>
	                        <li>Nově budete mít možnost výběru zda chcete založit nové předplatné nebo zda chcete přidat do stávajícího</li>
	                        </ol>
	                        </p>
	                   
	                    <button type="button" href="/" id="add-p-yes">Přidat další produkty</button>
	                    <button type="button" id="add-p-no" style="background-color: #fe0000">Zavřít</button>
	              
	                </div>
	            </div>`, 'add-new-product-modal')}
		</div>`;
	};

	var loadNextCalendar = function (subscriptions) {

		var children = {};
		subscriptions.forEach(function (subscription) {
			subscription.children.forEach(function (child) {
				if(children[subscription.code] === undefined) {
					children[subscription.code] = [];
				}
				children[subscription.code].push(child.childName);
			})
		})

		api.getData('my-full-calendar', {guid: getCustomerGuid()})
			.done(function (data) {
				var dateTable = '';
				data.forEach(function (date, i) {
					dateTable += `
							<tr>
								<th style="padding: 5px 0">${date.replaceDate ? `<del>${formatDate(date.regularDate)}</del>` : formatDate(date.regularDate)}</th>
								
								<td>${date.subscribeCode}</td>
								<td>${(children[date.subscribeCode] === undefined  ? 'Nemáte žádné dítě v předplatném' : children[date.subscribeCode].join(', '))}</td>
								<td>${date.period.text}</td>
								
								<td>
									<input type="date" data-id="${date.id}" data-subId="${date.subscribeId}" value="${date.replaceDate}" class="change-date" min="${date.minDate}" max="${date.maxDate}" />
								</td>
							</tr>
							</tr>`;
				})

				var calendar = `<table style="margin-bottom: 30px" class="subscription-calendar child">
					<thead>
						<tr>
							<th>Datum</th>
							<th>Kód</th>
							<th>Děti v předplatném</th>
							<th>Perioda odesílání</th>
							<th>Posunout na</th>
						</tr>
					</thead>
					<tbody id="date-content">
						${dateTable}
					</tbody>
				</table>`;

				$('#calendar-next-sending').html(calendar);
			})
	}

	var mySubscriptionContent = function () {
		$('#content-in header h1').text('Moje předplatné');
		$('#content-in div:first').remove();

		if(subscriptions.length === 0) {
			showSpinner();
			api.getData('my-subscription', {guid: getCustomerGuid()})
				.done(function (data) {
					hideSpinner();
					$('body').addClass('in-my-subscription');
					subscriptions = data;

					if(window.location.hash.indexOf('#subscription-') > -1 || subscriptions.length === 1) {
						var index = parseInt(subscriptions.length === 1 ? 0 : window.location.hash.replace('#subscription-', ''));
						$('#content-in article table, #calendar-title, #calendar-next-sending').remove();
						$('#content-in article').append(renderDetail(subscriptions[index < subscriptions.length ? index : 0]));
					} else {
						$('.my-subscription').remove()
						$('#content-in article').append(renderTable(subscriptions));
						loadNextCalendar(data)
					}
				})

		} else {
			if(window.location.hash.indexOf('#subscription-') > -1 || subscriptions.length === 1) {
				var index = parseInt(subscriptions.length === 1 ? 0 : window.location.hash.replace('#subscription-', ''));
				$('#content-in article table, #calendar-title, #calendar-next-sending').remove();
				$('#content-in article').append(renderDetail(subscriptions[index < subscriptions.length ? index : 0]));
			} else {
				$('.my-subscription').remove()
				$('#content-in article').append(renderTable(subscriptions));
				loadNextCalendar(subscriptions)
			}
		}
	}
	$(window).on('hashchange', function() {
		if (window.location.hash.indexOf('#subscription') > -1) {
			mySubscriptionContent();
		}
	});
	if (window.location.hash.indexOf('#subscription') > -1) {
		mySubscriptionContent();
	}


	$(document).on('click', '.add-products', function (e) {
		e.preventDefault();
		$('.add-new-product-modal').show();
	} )

	$(document).on('submit', '.my-subscription .sub-delete', function (e) {
		e.preventDefault()
		if(confirm("Opravdu si přejete odebrat produkt z HomeBoxu?")) {
			showSpinner();
			api.deleteData('delete-subscription-item', {
				subId: $(this).find('.id').val(),
				itemId: $(this).find('.item-id').val(),
				guid: getCustomerGuid(),
			}).done(function () {
				window.location.reload();
			})
		}
	})

	$(document).on('click', '.in-my-subscription .add-pcs, .in-my-subscription .remove-pcs', function (e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		var input = $(this).parent().find('.pcs');
		var id = $(this).parent().find('[name="itemId"]').val();
		var subId = $(this).parent().find('[name="id"]').val();
		var productCode = $(this).parent().find('[name="productCode"]').val();
		var value = parseInt(input.val());

		if ($(this).hasClass('add-pcs')) {
			value++;
		} else if(value > 1) {
			value--;
		}
		input.val(value);

		showSpinner();
		api.patchData(
			'update-item-quantity',
			{},
			{ guid: getCustomerGuid(), productCode, subscriptionId: parseInt(subId), itemId: id, quantity: value }
		).done(function (data) {
			window.location.reload();
			//hideSpinner()
		});
	})

	$(document).on('change', '.in-my-subscription .pcs', function (e) {
		e.stopImmediatePropagation();
		if($(this).val() <= 0) {
			e.preventDefault();
			alert('Množství musí být více než 0');
			$(this).val($(this).prop("defaultValue"));
			return;
		}

		var value = parseInt($(this).val());
		var id = $(this).closest('form').find('[name="itemId"]').val();
		var subId = $(this).closest('form').find('[name="id"]').val();
		var productCode = $(this).closest('form').find('[name="productCode"]').val();


		showSpinner();
		api.patchData(
			'update-item-quantity',
			{},
			{ guid: getCustomerGuid(), productCode, subscriptionId: parseInt(subId), itemId: id, quantity: value }
		).done(function (data) {
			window.location.reload();
			//hideSpinner()
		});


	})

	$(document).on('click', '#active_smart_sub', function (e) {
		e.preventDefault();
		$('.active-smart-sub').show();
		var subId = $(this).data('id');
		$('.active-smart-sub').find('#active-smart-sub-yes').data('id', subId);
	})
	$(document).on('click', '#active-smart-sub-no', function (e) {
		e.preventDefault();
		$('.active-smart-sub').hide();
	})

	$(document).on('click', '#active-smart-sub-yes', function (e) {
		e.preventDefault();
		var subId = $(this).data('id');
		showSpinner();
		api.patchData(
			'change-smart-subscription-status',
			{},
			{ guid: getCustomerGuid(), subscriptionId: parseInt(subId), status: 'ACTIVE' }
		).done(function (data) {
			window.location.reload();
			//hideSpinner()
		});
	})





	$(document).on('click', '#cancel_smart_sub', function (e) {
		e.preventDefault();
		$('.cancel-smart-sub').show();
		var subId = $(this).data('id');
		$('.cancel-smart-sub').find('#cancel-smart-sub-yes').data('id', subId);
	})
	$(document).on('click', '#cancel-smart-sub-no', function (e) {
		e.preventDefault();
		$('.cancel-smart-sub').hide();
	})

	$(document).on('click', '#cancel-smart-sub-yes', function (e) {
		e.preventDefault();
		var subId = $(this).data('id');
		showSpinner();
		api.patchData(
			'change-smart-subscription-status',
			{},
			{ guid: getCustomerGuid(), subscriptionId: parseInt(subId), status: 'CANCEL' }
		).done(function (data) {
			window.location.reload();
			//hideSpinner()
		});
	})




	$(document).on('click', '#cancel_sub', function (e) {
		e.preventDefault();
		$('.sub-cancel-modal').show();
		var subId = $(this).data('id');
		$('.sub-cancel-modal').find('#cancel-sub-yes').data('id', subId);
	})


	$(document).on('click', '#cancel-sub-no, #unpause-sub-no, #pause-sub-no', function (e) {
		e.preventDefault();
		$('.sub-cancel-modal, .sub-pause-modal, .sub-unpause-modal').hide();
	})

	$(document).on('click', '#cancel-sub-yes', function (e) {
		e.preventDefault();
		var subId = $(this).data('id');
			showSpinner();
			api.patchData(
				'change-subscription-status',
				{},
				{ guid: getCustomerGuid(), subscriptionId: parseInt(subId), status: 'CANCELLED' }
			).done(function (data) {
				window.location.reload();
				//hideSpinner()
			});
	})

	$(document).on('click', '.btn-switch-pause', function (e) {
		e.preventDefault();
		$('.sub-pause-modal').show();
		var subId = $(this).data('id');
		$('.sub-pause-modal').find('#pause-sub-yes').data('id', subId);
	})

	$(document).on('click', '.btn-switch-unpause', function (e) {
		e.preventDefault();
		$('.sub-unpause-modal').show();
		var subId = $(this).data('id');
		$('.sub-unpause-modal').find('#unpause-sub-yes').data('id', subId);
	})

	$(document).on('click', '#add-p-yes', function(e) {
		e.preventDefault();
		window.location.href = "/";
	})
	$(document).on('click', '#add-p-no', function(e) {
		e.preventDefault();
		$('.add-new-product-modal').hide();
	})

	$(document).on('click', '#pause-sub-yes', function (e) {
		e.preventDefault();
		var subId = $(this).data('id');
			showSpinner();
			api.patchData(
				'change-subscription-status',
				{},
				{ guid: getCustomerGuid(), subscriptionId: parseInt(subId), status: 'PAUSED' }
			).done(function (data) {
				window.location.reload();
				//hideSpinner()
			});
	})

	$(document).on('click', '#unpause-sub-yes', function (e) {
		e.preventDefault();
		var subId = $(this).data('id');
			showSpinner();
			api.patchData(
				'change-subscription-status',
				{},
				{ guid: getCustomerGuid(), subscriptionId: parseInt(subId), status: 'ACTIVE' }
			).done(function (data) {
				window.location.reload();
				//hideSpinner()
			});
	})

	$(document).on('change', '.change-date', function (e) {
		var $this = $(this);
		var tr = $this.closest('tr');
		var th = tr.find('th');
		showSpinner();

		setTimeout(function (){
			api.patchData(
				'update-calendar-date',
				{},
				{ guid: getCustomerGuid(), subId: parseInt($this.data('subid')), calendarId: parseInt($this.data('id')), replaceDate: $this.val() }
			).done(function () {
				if($this.val()) {
					th.html('<del>' + th.text() + '</del>');
				} else {
					th.html(th.text());
				}
				hideSpinner()
			});

		}, 300)
	});

}



